<template>
	<div
		id="cardMinimize"
		class="card-minimize"
		:class="[expanded ? 'expanded' : '']"
	>
		<div class="row">
			<div class="col-12">
				<label>Título</label>
				<input
					type="text"
					v-model="cardData.title"
					class="form-control"
				/>
			</div>
			<div class="col-12 mb-2">
				<div class="d-flex list--suggestion">
					<label class="ml-2 mt-2">Sugestões:</label>
					<span
						class="item--suggestion"
						@click="cardData.title = `${cardData.title} ${item}`"
						v-for="item in filterSuggestions"
						:key="item"
						>{{ item }}</span
					>
				</div>
			</div>
		</div>
		<div class="total-imageList">
			<ImagesList
				:countList="this.cardData.contents.length"
				:imageList="filterImages"
				@addPictures="addPictures($event)"
				@changeExpand="changeExpand"
				@removeImage="removeImage($event)"
				v-if="expanded == false"
			/>
			<ImagesList
				:countList="this.cardData.contents.length"
				:imageList="getAllImages"
				:showAll="true"
				@addPictures="addPictures($event)"
				@removeImage="removeImage($event)"
				v-else
			/>
		</div>
	</div>
</template>

<script>
	export default {
		name: "cardMinimize",
		data() {
			return {
				expanded: false,
			};
		},
		props: {
			cardData: {
				required: false,
			},
		},
		methods: {
			removeImage(item) {
				let image = this.cardData.contents.indexOf(item);
				this.cardData.contents.splice(image, 1);
			},
			changeExpand() {
				this.expanded = !this.expanded;
			},
			addPictures(pictures) {
				pictures.forEach((element) => {
					this.cardData.contents.unshift({
						content: element,
						source: "mediaManager",
						type: "image",
					});
				});
			},
		},
		computed: {
			filterSuggestions() {
				return this.cardData.suggestions.filter(
					(element) => element != "" && element != this.cardData.title
				);
			},
			getAllImages() {
				return this.cardData.contents.filter(
					(img) => img.type == "image" || img.type == "script"
				);
			},
			filterImages() {
				let images = this.cardData.contents.filter(
					(img) => img.type == "image" || img.type == "script"
				);
				if (images.length > 4) {
					images.splice(4, 100);
				}
				return images;
			},
			filterLocation() {
				let locations = this.cardData.contents.filter(
					(item) => item.country != null && item.type == "image"
				);
				if (locations) {
					return locations;
				} else {
					return false;
				}
			},
		},
		components: {
			ImagesList: () => import("../molecules/ImagesList"),
		},
	};
</script>

<style scoped>
	.card-minimize {
		text-align: left;
		width: 311px;
		background-color: #fff;
		border-radius: 6px;
		padding: 10px;
		cursor: pointer;
		white-space: normal;
		margin: 0 10px;
		position: relative;
		box-shadow: 0 6px 16px 0px #0000001a;
		min-height: 339px;
	}
	.card-minimize.expanded {
		height: unset !important;
	}
	.total-locations {
		display: inline-block;
		position: absolute;
		left: 14px;
		bottom: 14px;
		font-size: 11px;
		color: #707070;
		width: 211px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.item--suggestion {
		background-color: #f8f8f8;
		color: #9a9a9a;
		height: 20px;
		padding: 2px 8px;
		border-radius: 20px;
		display: inline-block;
		cursor: pointer;
		margin: 5px 10px 0 0;
		font-size: 0.62rem;
	}
	.list--suggestion {
		overflow-x: auto;
		white-space: nowrap;
		padding: 10px 0 13px;
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/CardMinimize.vue